import React, { useState, useEffect } from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { saveAs } from 'file-saver';
// import '../styles.css';
import moment from 'moment';
import { Button, Modal } from 'react-bootstrap';

import { toast } from 'react-toastify';
import Loader from '../../shared/common/loader';
import useRazorpay, { RazorpayOptions } from 'react-razorpay';
import SipHttp from './sip.service';

import { useHistory } from 'react-router-dom';
import { userStore } from 'store/UserStore';
import BuySellService from '../../services/buy-sell.service';
// import ConfettiExplosion, { ConfettiProps } from 'react-confetti-explosion';
import { load } from '@cashfreepayments/cashfree-js';
import PaymentFailedModal from './PaymentFailedModal';

interface PropsType {
  handleModal: any;
  isShow: boolean;
  data: any;
  displaySummary: boolean;
  emandates?: string;
  sipMethod?: string;
  errorMessage?: string;
  successMessage?: string;
  couponCode?: string;
  couponValidationError?: string;
}

const SipSummary: React.FC<PropsType> = ({
  handleModal,
  isShow,
  data,
  displaySummary,
  emandates,
  sipMethod,
  errorMessage,
  successMessage,
  couponCode,
  couponValidationError,
}) => {
  const [loading, setLoading] = useState<any>(false);
  const [message, setMessage] = useState('');
  const [cashfreeLoading, setCashfreeLoading] = useState(false);
  const [cashfreeSubscriptionId, setCashfreeSubscriptionId] = useState('');
  const [closepFailedModal, setClosepFailedModal] = useState(false);

  const Razorpay = useRazorpay();
  const [customerId, setUser, user, selectedAccount] = userStore(
    (state: any) => [
      state.customerId,
      state.setUser,
      state.user,
      state.selectedAccount,
    ]
  );
  const [razorpay, setRazorpay] = useState<any>({
    customerId: customerId,
    amount: null,
    paymentMethod: 'NEBK',
  });

  // console.log(errorMessage, "@errorMessage");
  // console.log(data, '@discount');

  let history = useHistory();

  const checkPaymentStatus = async (paymentId, orderId) => {
    try {
      let payload = {
        paymentId,
        orderId,
      };
      setLoading(true);
      //   const res = await BuySellService.checkPaymentStatus(payload, '');
    } catch (error) {
    } finally {
      toast.success('Successful');
      setLoading(false);
      handleModal(false);
      // history.push('/sip');
    }
  };

  const onSuccessRpyMandate = async () => {
    handleModal(false);
    // history.push('/sip');
    const toastMessage = encodeURIComponent(
      'E-mandate request has been send successfully'
    );
    window.location.href = `/sip?tab=sippassbook&toastMessage=${toastMessage}`;
    // setTimeout(() => {
    //   toast.success('E-mandate request has been send successfully');
    // }, 1000);
  };

  const onFailureRpyMandate = async () => {
    handleModal(false);
    // history.push('/sip');
    history.push('/sip');

    setTimeout(() => {
      toast.error('Payment Failed');
    }, 1000);
  };
  /**
   * Download invoice pdf
   */
  const setInitialStateRazorpay = () => {
    setRazorpay({
      customer_id: '',
      order_id: '',
    });
  };
  /**
   * Download order summary pdf
   */
  const placeOrder = async (successMessage?: any) => {
    console.log(successMessage, '@successMessage111');

    try {
      if (emandates == 'withoutMandate' || sipMethod == 'paymanual') {
        setLoading(true);
        const resp = await SipHttp.createSIPWithoutEM(customerId, data);
        if (resp?.status == 200) {
          setTimeout(() => {
            toast.success('SIP created successfully');
          }, 1000);
          setLoading(false);

          handleModal(false);
          history.push('/sip?tab=sippassbook');
        }
      } else {
        let resp;
        if (emandates == 'withMandateUPI') {
          if (data?.frequency == 'daily') {
            const daily_payload = {
              plan_name: data?.plan_name,
              plan_recurring_amount: Number(data?.installment_amt),
              plan_currency: 'INR',
              metal: data?.metal,
              duration: data?.duration,
              subscription_first_charge_time: data?.start_date,
              frequency: data?.frequency,
              discount_name: data?.discount_name,
              is_auto_renew: data?.is_auto_renew
            };
            resp = await SipHttp.createDailySIPWithEM(daily_payload);
            console.log('cashresp', resp?.data?.data?.subscriptionSessionId);
            setCashfreeSubscriptionId(resp?.data?.data?.subscriptionId);
          } else {
            resp = await SipHttp.createSIPWithEM(
              customerId,
              user?.userId,
              true,
              data?.frequency,
              successMessage?.name
            );
          }
        } else {
          resp = await SipHttp.createSIPWithEM(
            customerId,
            user?.userId,
            false,
            data?.frequency,
            successMessage?.name
          );
        }
        handleModal(false);
        if (resp?.status == 200) {
          await authFunc(resp?.data?.data);
        }
      }
    } catch (err) {
      toast.error('Something Went Wrong');
      setLoading(false);

      console.log(err);
    }
  };

  const cashfree = async (subId) => {
    setCashfreeLoading(true);
    const res = await load({
      mode: 'sandbox',
    });
    res
      .subscriptionsCheckout({
        subsSessionId: subId,
        redirectTarget: '_blank',
      })
      .then(function (result) {
        // setCashfreeLoading(false);
        if (result.error) {
          document.getElementById('paymentMessage').innerHTML =
            result.error.message;
        }
      });
    console.log('cashfree', res);
  };
  const authFunc = async (rpyData) => {
    // const resp1 = await SipHttp.createSIPWithEM(customerId);
    console.log('subId', cashfreeSubscriptionId);
    const { rpyOrderId, rpyCustomerId } = rpyData;
    let redirect_url: any;
    const options: any = {
      key: process.env.REACT_APP_RAZORPAY_KEY,

      //   amount: (data?.installment_amt * 100).toString(),

      name: 'eBullion',
      description: 'Create SIP',
      image:
        'https://ebullion-dev.s3.ap-south-1.amazonaws.com/assets/eb-logo.png',
      // order_id: resp1?.data?.data?.rpyOrderId,
      order_id: rpyOrderId,
      customer_id: rpyCustomerId,
      recurring: 1,
      // callback_method: 'get',
      // callback_url: 'https://secure.ebullion.in/sip',
      handler: async (response: any) => {
        setLoading(true);
        if (response.razorpay_payment_id) {
          await onSuccessRpyMandate();
          // redirect_url = 'http://secure.ebullion.in/sip';
        } else {
          await onFailureRpyMandate();

          // redirect_url = 'http://secure.ebullion.in/sip';
        }
        // location.href = redirect_url;

        // const payload = {
        //   customerId: razorpay.customerId,
        //   razorpayOrderId: response.razorpay_order_id,
        //   razorpayPaymentId: response.razorpay_payment_id,
        //   razorpaySignature: response.razorpay_signature,
        // };
        //     // const res: any =
        //     //   paymentMethod === 'UPI'
        //     //     ? await BuySellService.verifyUPIPaymentRazorpay(payload)
        //     //     : await BuySellService.verifyNEBKPaymentRazorpay(payload);
        //     // if (res.status === 200 && res.data.data) {
        //     // setInitialStateRazorpay();
        //     // await checkPaymentStatus(
        //     //   response.razorpay_payment_id,
        //     //   data?.ebOrderRef
        //     // );
        //     // }

        setInitialStateRazorpay();
        // onSuccessRpyMandate();
        // await checkPaymentStatus(
        //   response.razorpay_payment_id,
        //   response.razorpay_order_id
        // );
      },
      prefill: {
        name: user.displayName,
        email: user.email.value,
        contact: user.mobile.value,
      },
      notes: {
        ...data,
      },
      theme: {
        hide_topbar: false,
        color: '#141034',
        backdrop_color: 'rgba(0, 0, 0, 0.90)',
      },
      // redirect: true,‹
      // timeout: 180,
    };

    const razorPay = new Razorpay(options);
    console.log('open cashfree', data?.frequency);

    if (data?.frequency !== 'daily') {
      razorPay.open();
    } else {
      const subId = rpyData?.subscriptionSessionId;
      cashfree(subId);
    }
  };

  const checkDailySipStatus = async () => {
    try {
      const data = { subscriptionId: cashfreeSubscriptionId };
      const res = await SipHttp.createDailySIPStatus(data);
      console.log('cashstatus', res);
      if (res?.data?.data?.status == 'ACTIVE') {
        setCashfreeLoading(false);
        const toastMessage = encodeURIComponent(
          'SIP created successfully'
        );
        history.push(`/sip?tab=sippassbook&toastMessage=${toastMessage}`);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const redirectFunc = () => {
    history.push('/sip?tab=sippassbook');
  };
  const closepFailedModalFunc = () => {
    setClosepFailedModal(false);
    redirectFunc();
  };

  useEffect(() => {
    if (!cashfreeLoading) return; // Ensure it only runs when `cashfreeLoading` is true

    const intervalId = setInterval(() => {
      checkDailySipStatus();
    }, 5000);

    const timeoutId = setTimeout(() => {
      setCashfreeLoading(false); // Stop further API calls
      clearInterval(intervalId);
      // history.push('/sip?tab=sippassbook');
      setClosepFailedModal(true);
    }, 120000);

    return () => {
      clearInterval(intervalId);
      clearTimeout(timeoutId);
    };
  }, [cashfreeLoading]);

  return (
    <>
      {loading || cashfreeLoading ? <Loader /> : null}
      {data && (
        <>
          <Modal
            show={isShow}
            onHide={() => handleModal(false)}
            // bsPrefix='md__'
            dialogClassName=''
          >
            <Modal.Header closeButton>
              <Modal.Title>Plan Details</Modal.Title>
            </Modal.Header>
            <Modal.Body className='px-5'>
              <div className='row py-3 justify-content-between border-bottom'>
                {/* <div className='col-md-6 mb-2'>Order Status</div>
                  <div className='col-md-6  mb-2 text-end'>
                    <div className='badge bg-secondary'>
                      <b>{data.status}</b>
                    </div>
                  </div> */}
                <div className='col-md-6 col-6 mb-3'>Start Date</div>
                <div className='col-md-6 col-6 mb-3 text-md-end text-end'>
                  <div className='badge bg-secondary'>
                    <b> {moment(data?.start_date).format('DD-MMM-yyyy')}</b>
                  </div>
                </div>
                <div className='col-md-6 col-6 mb-3'>Duration</div>
                {/* <div className='col-md-6 mb-2 text-end'> */}
                <div className='col-md-6 col-6 mb-3 text-md-end text-end'>
                  <b>{data?.duration} Months</b>
                </div>
                <div className='col-md-6 col-6 mb-3'>Frequency</div>
                {/* <div className='col-md-6 mb-2 text-end'> */}
                <div className='col-md-6 col-6 mb-3 text-md-end text-end'>
                  <b>{data?.frequency?.toUpperCase()}</b>
                </div>
                <div className='col-md-6 col-6 mb-3'>
                  {data?.installment_amt ? 'Amount' : 'Grams'}
                </div>
                {/* <div className='col-md-6 mb-2 text-end'> */}
                <div className='col-md-6 col-6 mb-3 text-md-end text-end'>
                  <b>
                    {data?.installment_amt
                      ? `₹${data?.installment_amt}`
                      : `${data?.grams}g`}
                  </b>
                </div>
                <div className='col-md-6 col-6 mb-3'>Payment Method</div>
                {/* <div className='col-md-6 mb-2 text-end'> */}
                <div className='col-md-6 col-6 mb-3 text-md-end text-end'>
                  {sipMethod == 'paymanual' ? (
                    <b>PAY MANUAL</b>
                  ) : (
                    <b>E-MANDATE</b>
                  )}
                </div>
                {sipMethod !== 'paymanual' && (
                  <>
                    <div className='col-md-6 col-6 mb-3'>E-Mandate Status</div>
                    {/* <div className='col-md-6 mb-2 text-end'> */}
                    <div className='col-md-6 col-6 mb-3 text-md-end text-end'>
                      <b>{data?.bank == '' ? 'PENDING' : 'CONFIRMED'}</b>
                    </div>
                  </>
                )}

                {sipMethod !== 'paymanual' && data?.is_auto_renew && (
                  <>
                    <div className="col-md-6 col-6 mb-3">
                      SIP Auto-Renew
                    </div>
                    <div className="col-md-6 col-6 mb-3 text-end">
                      <b>Enabled</b>
                    </div>
                  </>
                )}

              </div>

              {couponValidationError?.length > 0 && (
                <div
                  className='alert alert-danger d-flex justify-content-between align-items-center'
                  role='alert'
                  style={{
                    padding: '6px 10px',
                    fontSize: '12px',
                    marginTop: '14px',
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='16'
                      height='16'
                      fill='currentColor'
                      className='bi bi-exclamation-circle'
                      viewBox='0 0 16 16'
                      style={{ marginRight: '6px' }}
                    >
                      <path d='M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zm0-1A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm-.93-4.418a.5.5 0 0 1 .854.354v.79a.5.5 0 0 1-.854.354L5.118 11.316a.5.5 0 1 1 .354-.854l1.596 1.596V7.5a.5.5 0 0 1 1 0v4.098z' />
                    </svg>
                    <strong style={{ fontSize: '13px' }}>
                      {/* Coupon "{couponCode}" has expired. */}
                      {couponValidationError}.{' '}
                      <a
                        href='#'
                        className='text-decoration-underline'
                        onClick={(e) => {
                          e.preventDefault();
                          handleModal(false);
                          // Handle coupon removal logic here
                        }}
                      >
                        Please remove the coupon
                      </a>
                      .
                    </strong>
                  </div>
                </div>
              )}

              {successMessage && !errorMessage && (
                <>
                  <div
                    className='alert alert-success d-flex justify-content-between align-items-center'
                    role='alert'
                    style={{
                      padding: '6px 10px',
                      fontSize: '12px',
                      marginTop: '14px',
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='16'
                        height='16'
                        fill='currentColor'
                        className='bi bi-gift'
                        viewBox='0 0 16 16'
                        style={{ marginRight: '6px' }}
                      >
                        <path d='M3.5 0a3.5 3.5 0 0 1 2.45 5.95H10.5A3.5 3.5 0 1 1 13 5H3a3.5 3.5 0 0 1 .5-5zm0 1a2.5 2.5 0 0 0-1.995 4H5.5V1a2.5 2.5 0 0 0-2-.995zm9 0a2.5 2.5 0 0 0-2.5 2.5V5h4a2.5 2.5 0 0 0-1.5-4zM3.5 6h9a3.5 3.5 0 0 1 3.5 3.5v7a.5.5 0 0 1-.5.5H13V9H3v8H.5a.5.5 0 0 1-.5-.5v-7A3.5 3.5 0 0 1 3.5 6zM12 10v7h3.5a.5.5 0 0 0 .5-.5v-7A2.5 2.5 0 0 0 13.5 7h-1.5zm-8 0v7H.5a.5.5 0 0 1-.5-.5v-7a2.5 2.5 0 0 1 2.5-2.5H4z' />
                      </svg>
                      <strong style={{ fontSize: '13px' }}>
                        Congratulations! Coupon "{couponCode}" applied to your
                        SIP!
                      </strong>
                    </div>
                  </div>
                </>
              )}

              {errorMessage?.length > 0 && !successMessage && (
                <div
                  className='alert alert-danger d-flex justify-content-between align-items-center'
                  role='alert'
                  style={{
                    padding: '6px 10px',
                    fontSize: '12px',
                    marginTop: '14px',
                    color: 'red',
                    backgroundColor: '#f8d7da',
                    borderColor: '#f5c6cb',
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='16'
                      height='16'
                      fill='currentColor'
                      className='bi bi-exclamation-triangle-fill'
                      viewBox='0 0 16 16'
                      style={{ marginRight: '6px', color: 'red' }}
                    >
                      <path d='M7.938 2.016a.13.13 0 0 1 .125 0l6.856 3.905c.113.065.181.191.163.32l-1.048 6.872c-.024.156-.145.278-.294.302L8 15.98l-5.74-1.566c-.15-.024-.27-.146-.293-.302L.93 6.24c-.018-.129.05-.255.163-.32l6.855-3.905zM8 5c-.535 0-.954.462-.9.995l.417 4.983c.031.377.372.65.733.65s.702-.273.733-.65l.417-4.983c.054-.533-.365-.995-.9-.995zm-.002 8a.905.905 0 1 0 1.81 0 .905.905 0 0 0-1.81 0z' />
                    </svg>
                    <strong style={{ fontSize: '13px' }}>
                      Could not apply coupon "{couponCode}". Please{' '}
                      <a
                        href='#'
                        className='text-decoration-underline'
                        onClick={(e) => {
                          e.preventDefault();
                          handleModal(false);
                          // or implement a custom function to go back
                        }}
                      >
                        update your details
                      </a>{' '}
                      or{' '}
                      <a
                        href='#'
                        className='text-decoration-underline'
                        onClick={(e) => {
                          e.preventDefault();
                          handleModal(false);
                          // Handle coupon removal logic here
                        }}
                      >
                        remove the coupon
                      </a>
                      .
                    </strong>
                  </div>
                </div>
              )}

              <div className='d-grid py-3'>
                <Button
                  variant='primary'
                  className='btn-block'
                  onClick={(e) => placeOrder(successMessage)}
                  size='lg'
                  disabled={
                    errorMessage?.length > 0 ||
                    couponValidationError?.length > 0
                  }
                >
                  Authenticate
                </Button>
              </div>
            </Modal.Body>
          </Modal>

          <PaymentFailedModal
            showModal={closepFailedModal}
            closeModal={() => {
              setClosepFailedModal(false);
            }}
            cancel={closepFailedModalFunc}
            redirectFunc={redirectFunc}
          />
        </>
      )}
    </>
  );
};

export default SipSummary;
